import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import {
  ChecklistTemplateVersionMessages,
  MessageDesignBUtils
} from '../../content/components/message-design-b/message-design-b.utils';
import { RequestClientService } from '../../services/client/request-client.service';
import {
  ChecklistTemplateVersionAction
} from '../../states/checklist-template-version/checklist-template-version.action';
import { MessageModel } from '../../content/components/message-design-b/message.model';

export class SseImportEvent extends SseEventBase {

  type: SseEventType = 'import';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.OBJECT_IMPORT_STATE_CHANGED: {
          this.on.objectImportStateChanged$.next(resp.objectImportIds);
          break;
        }
        case NotificationReasonEnum.JOB_IMPORT_STATE_CHANGED: {
          this.on.jobImportStateChanged$.next(resp.jobImportIds);
          break;
        }
      }
    });
  }
}
